import Section from './section';
import IntroPhoto from '../assets/images/intro-photo.jpg';
import Button from './button';
import TextTypeAnimation from './text-type-animation';

const IntroSection = () => {
  return (
    <Section id="intro">
      <div className="intro-wrapper">
        <div className="intro">
          <div className="intro__info">
            <h2 className="intro__info__title">
              <TextTypeAnimation
                delay={0.5}
                className="intro__info__title__subtitle"
                text="Hi, my name is"
              />
              <TextTypeAnimation
                delay={1.4}
                className="intro__info__title__name"
                text="Andrii Chekanovskyi"
              />
            </h2>
            <p className="intro__info__subtitle">
              <TextTypeAnimation
                delay={2.4}
                duration={5}
                text="I'm a Software Engineer passionate about technology and problem-solving. I love
              building, learning, and improving to create impactful solutions."
              />
            </p>
            <div className="intro__info__btns">
              <a href="./Andrii_Chekanovskyi_CV.pdf" download="Andrii_Chekanovskyi_CV">
                <Button className="intro__info__btns__btn" variant="primary">
                  🚀 Check out my CV
                </Button>
              </a>
            </div>
          </div>
          <div className="intro__image">
            <div className="intro__image__wrapper">
              <img src={IntroPhoto} alt="Andrii Chekanovskyi" />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default IntroSection;
